import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReportsExecutionsResolverErrorStatesEnum {
    GetTradingGroupsFailed = ErrorStateScheduleEnum.PanelReportsExecutionsResolverErrorStatesStartIndex
}
